// platform_brand_v1: dynamic app-wide brand name resolved from the visiting domain
import React from 'react';
import API from './api';

let _name = localStorage.getItem('brand_name') || '';
export const brandName = () => _name || 'AUTO CHATS';

export function initBrand() {
  API.get('/api/site/context').then(({ data }) => {
    const n = data && data.custom && data.name ? data.name : '';
    if (n !== _name) {
      _name = n;
      if (n) { localStorage.setItem('brand_name', n); document.title = (data.title || n); /* brand_meta_v1 */ }
      else { localStorage.removeItem('brand_name'); }
      window.dispatchEvent(new Event('brandchange'));
    } else if (n) {
      document.title = (data.title || n); /* brand_meta_v1 */
    }
  }).catch(() => {});
}

export function useBrandName() {
  const [n, setN] = React.useState(brandName());
  React.useEffect(() => {
    const h = () => setN(brandName());
    window.addEventListener('brandchange', h);
    return () => window.removeEventListener('brandchange', h);
  }, []);
  return n;
}
